'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  account: {
    calendars: 'Calenders',
    button: {
      remove: 'Remove account', // ?
      cancel: 'Cancel',
      delete: 'Delete'
    },
    chooseLanguage: 'Interface Language',
    english: 'English',
    french: 'Français (French)',
    form: {
      name: 'Name',
      email: 'Email',
      change_password: 'Change password',
      new_password: 'New password',
      new_password_confirmation: 'Confirm new password',
      password: 'Current Password',
      submit: 'Submit'
    },
    meta_title: 'Account',
    popover: {
      title: 'Are you sure you want to delete your Caligram account?',
      confirm: 'Delete all the events where I am the sole manager.' // ?  Supprimer aussi tous les événements dont je suis la seule personne responsable
    },
    title: 'Account'
  },
  join: {
    explanation: 'Do you want to rejoin "%{name}" ?', // ?
    meta_title: 'Rejoin a calendar',
    submit: 'Rejoin',
    title: 'Rejoin a calendar'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/account.js
// module id = 2279
// module chunks = 0